var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"page-footer"},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }